import { FormControl } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Controller, useFormContext } from 'react-hook-form';
import { useUserPreferences } from '../../contexts/UserPreferencesContext';

type Props = {
  name: string;
  label: string;
  onChange?: () => void;
  isDisabled?: boolean;
  disablePast?: boolean;
  disableFuture?: boolean;
  minDate?: any;
  maxDate?: any;
  required?: boolean;
};

const RHFDatePicker = ({
  name,
  label,
  onChange: propsOnChange = () => undefined,
  isDisabled,
  required,
  ...others
}: Props) => {
  const { control } = useFormContext();
  const { preferences } = useUserPreferences();
  const dateFormat = preferences.dateFormat || 'DD.MM.YYYY';

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Controller
        name={name}
        control={control}
        render={({
          field: { onChange, value, ref, ...field },
          fieldState: { error },
        }) => {
          return (
            <FormControl sx={{ width: '100%' }}>
              <DatePicker
                {...field}
                closeOnSelect={false}
                reduceAnimations
                format={dateFormat}
                value={value ?? null}
                onChange={(newValue) => {
                  onChange(newValue);
                  propsOnChange();
                }}
                disabled={isDisabled}
                slotProps={{
                  actionBar: { actions: ['today', 'cancel', 'accept'] },
                  textField: {
                    label,
                    error: !!error,
                    helperText: error ? error.message : '',
                    fullWidth: true,
                    placeholder: dateFormat,
                    required,
                  },
                }}
                {...others}
              />
            </FormControl>
          );
        }}
      />
    </LocalizationProvider>
  );
};

export default RHFDatePicker;
